export const transition = "ease-in-out duration-200";
export const bgHoverPrimary = "hover:bg-primary-50 " + transition;
